export default __webpack_public_path__ + "static/media/img_8.b582140b.JPG";